/* Company Confidential, Copyright (c) 2024 Signant Health. All Rights Reserved. */
import { jwtDecode } from 'jwt-decode';

export const getUserInfoFromAccessToken = (accessToken) => {
  try {
    let initials = '';
    const decodedToken = jwtDecode(accessToken);

    const { sub, exp } = decodedToken;
    const { entitlement = '' } = decodedToken;
    if (typeof sub === 'string' && sub.length > 0) {
      initials += sub.charAt(0).toUpperCase();
      initials += sub.split('.')[1].charAt(0).toUpperCase();
    }
    return { entitlement, initials, email: sub, exp };
  } catch (error) {
    // In case the access token is undefined or malformed
    // jwtDecode() will throw.
    console.error('Cannot get user initials from token');
    return { initials: '  ' };
  }
};

export const getUserInfoFromIdToken = (rawIdToken) => {
  try {
    let initials = '';

    const hasOuterQuotes = /^"(.*)"$/.test(rawIdToken);
    const idToken = hasOuterQuotes ? rawIdToken.replace(/^"(.*)"$/, '$1') : rawIdToken;

    const { firstName, lastName } = JSON.parse(idToken);
    if (typeof firstName === 'string' && firstName.length > 0) {
      initials += firstName.charAt(0).toUpperCase();
    }
    if (typeof lastName === 'string' && lastName.length > 0) {
      initials += lastName.charAt(0).toUpperCase();
    }
    return { initials };
  } catch (error) {
    // In case the id_token is undefined or malformed
    // JSON.parse() will throw.
    console.error('Cannot get user initials from token');
    return { initials: '  ' };
  }
};
